import React, { FC } from "react";
import { ICohortComment } from "../../stores/jotai/base";
import ScoringCommentCard from "./ScoringCommentCard";
import { Grid } from "@mui/material";

interface ScoringCommentListProps {
    comments: ICohortComment[];
    ratingQuestions?: string[];
}

const ScoringCommentList: FC<ScoringCommentListProps> = (props) => {
    const { comments, ratingQuestions } = props;

    return (
        <Grid
            container={true}
            spacing={2}
        >
            {comments?.map((comment) => (
                <Grid
                    key={comment?.commentID}
                    item={true}
                    xl={6}
                    sm={12}
                >
                    <ScoringCommentCard
                        key={comment.commentID}
                        comment={comment}
                        ratingQuestions={ratingQuestions}
                    />
                </Grid>
            ))}
        </Grid>
    );
};

export default ScoringCommentList;
